declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export function trackSignupConversion() {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', 'conversion', {
    send_to: 'AW-18124506619/OwvOCOGmvaYcEPuLuMJD',
    value: 1.0,
    currency: 'USD',
  });
}
